import { logCallEvent } from "./LogCallEvent";
let isRecordingEnabled = false;
let paAnnounceEnabled = false;

export const isCallRecordingEnabled = (reservation) => {
    const mpAttributes = reservation?.task?.attributes?.mp || {
        record: false,
        PaAnnounce: false
    };
    const accountId = mpAttributes.routing?.account_id || '';
    const callId = reservation?.task?.attributes?.call_sid || '';
    isRecordingEnabled = mpAttributes.record === true;
    paAnnounceEnabled = mpAttributes.PaAnnounce === true;
    
    if (isRecordingEnabled) {
        const event = new CustomEvent('call_recording_status', {
            detail: { 
                isEnabled: true,
                paAnnounce: paAnnounceEnabled,
                accountId: accountId,
                callId: callId
            }
        });
        document.dispatchEvent(event);
    }
    return isRecordingEnabled;
}

const dispatchCallRecordingDeclined = (callId, accountId) => {
    const event = new CustomEvent('call_recording_declined', {
        detail: { 
            callId: callId,
            accountId: accountId
        }
    });
    document.dispatchEvent(event);
}

window.addEventListener('load', () => {
    const recordingDeclineButton = document.getElementById('recording-declined');

    if (recordingDeclineButton) {
        recordingDeclineButton.addEventListener('click', () => {
            const callId = recordingDeclineButton.getAttribute('data-call-id') || 'N/A';
            const accountId = recordingDeclineButton.getAttribute('data-account-id') || 'N/A';
            recordingDeclineButton.setAttribute('disabled', 'disabled');
            dispatchCallRecordingDeclined(callId, accountId);
        });
    }
})

const recordingDeclined = (state = 'enabled', event) => {
    const button = document.getElementById('recording-declined');
    const accountId = event?.detail?.accountId || 'N/A';
    const callId = event?.detail?.callId || 'N/A';
    if (button) {
        if (state === 'enabled') {
            button.removeAttribute('disabled');
            button.setAttribute('data-call-id', callId);
            button.setAttribute('data-account-id', accountId);
            button.classList.remove('hidden');
        } else {
            button.setAttribute('disabled', 'disabled');
            button.classList.add('hidden');
        }
    }
}

document.addEventListener('call_recording_status', (event) => {
    const [isEnabled, paAnnounce] = [event.detail.isEnabled, event.detail.paAnnounce];
    if (isEnabled) {
        recordingDeclined('enabled', event);
    } else {
        recordingDeclined('disabled');
    }
});

document.addEventListener('before_operator_screen_render', () => {
    const recordingTextElement = document.querySelector('[data-call-recording-text]');
    const recordingContainer = document.querySelector('[data-call-recording]');

    if (!recordingTextElement || !recordingContainer) {
        return;
    }
    if (isRecordingEnabled && paAnnounceEnabled) {
        recordingTextElement.textContent = `, this call may be recorded for quality and training purposes`;
        recordingContainer.classList.remove('hidden');
    } else {
        recordingTextElement.textContent = '';
        recordingContainer.classList.add('hidden');
    }
})

document.addEventListener('operatorScreenClosed', () => {
    console.log('Operator screen closed - hiding call recording notice');
    const recordingContainer = document.querySelector('[data-call-recording]');
    const recordingTextElement = document.querySelector('[data-call-recording-text]');
    const recordingDeclineButton = document.getElementById('recording-declined');

    if (recordingDeclineButton) {
        recordingDeclineButton.setAttribute('disabled', 'disabled');
        recordingDeclineButton.classList.add('hidden');
    }
    if (recordingContainer && recordingTextElement) {
        recordingContainer.classList.add('hidden');
        recordingTextElement.textContent = '';
    }
});

document.addEventListener('call_recording_declined', (event) => {
    const callSid = event?.detail?.callId || 'N/A';
    const accountId = event?.detail?.accountId || 'N/A';
    
    fetch('/twilio/recording_decline', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
            audit: {
                reason: 'Recording deleted - caller declined',
                callStartDateTime: new Date().toISOString(),
                accountId: accountId,
                paName: myName,
            },
            callSid: callSid
         })
    }).then(response => {
        logCallEvent(callId, '[BUTTON CLICK] Recording decline logged');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    }).then(data => {
        logCallEvent(callId, '[BUTTON CLICK] Recording deleted after decline');
    }).catch(error => {
        logCallEvent(callId, '[BUTTON CLICK] Error logging recording decline: ' + error.message);
    });
});

document.addEventListener('call_recording_paused', (event) => {
    if (isCallRecordingEnabled === false) {
        logCallEvent(event?.detail?.callId || 'N/A', 'Call recording is not enabled, skipping pause logging.');
        return;
    }

    const callSid = event?.detail?.callId || 'N/A';

    fetch('/twilio/recording_paused', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
            callSid: callSid
         })
    }).then(response => {
        if ($("body").attr("data-region") == "GB") {
            logCallEvent(callId, '[BUTTON CLICK] Recording pause logged');
        }
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    }).then(data => {
        console.log('Recording pause logged successfully:', data);
    }).catch(error => {
        console.error('There was a problem with the fetch operation:', error);
    });
})

document.addEventListener('call_recording_resumed', (event) => {
    if (isCallRecordingEnabled === false) {
        console.log('Call recording is not enabled, skipping resume logging.');
        return;
    }

    console.log('Call recording resumed event detected.');
    const callSid = event?.detail?.callId || 'N/A';

    fetch('/twilio/recording_resumed', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
            callSid: callSid
         })
    }).then(response => {
        logCallEvent(callId, '[BUTTON CLICK] Recording resume logged');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    }).then(data => {
        console.log('Recording resume logged successfully:', data);
    }).catch(error => {
        console.error('There was a problem with the fetch operation:', error);
    });
});